import styled from '@emotion/styled';
import { TextField } from '@mui/material';
import { colors } from 'theme/colors';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export const StyledTextField = styled(TextField)({
  fieldset: {
    borderRadius: 4,
  },
  input: {
    fontSize: 14,
    height: 40,
    backgroundColor: `${colors.white}`,
    boxSizing: 'border-box',
    padding: '8px 12px !important',
  },
  textarea: {
    fontSize: 14,
  },
  'input::placeholder, textarea::placeholder': {
    fontSize: 14,
    fontWeight: 400,
    color: `${colors.gray300}`,
    fontFamily: 'NotoSansRegular, sans-serif',
    opacity: 1,
  },
  '& .MuiOutlinedInput-root': {
    height: 40,
    marginBottom: 3,
    backgroundColor: colors.white,

    '& fieldset': {
      borderColor: colors.gray300,
    },
  },
  '& .MuiAutocomplete-input': {
    marginBottom: 4,
    marginTop: '-9px',
    marginLeft: '-10px',
    marginRight: '-10px',
    paddingLeft: '10px !important',
  },
  '& .MuiAutocomplete-endAdornment': {
    right: '4px !important',
    bottom: '3px !important',
  },
});

export const StyledDatePicker = styled(DatePicker)(() => ({
  '& ': {
    color: 'red',
  },
  '& .MuiOutlinedInput-input': {
    padding: '8px 12px',
  },
  '& .MuiOutlinedInput-root': {
    height: 40,
    fontSize: 14,
    backgroundColor: colors.white,
  },
}));

export const StyledInnerWrapper = styled.div`
  font-size: 14px;
  margin-bottom: 3px;
  height: 40px;

  & .MuiOutlinedInput-root {
    width: 100%;
    height: 40px;
  }
  '& .MuiOutlinedInput-input' {
    padding: 8px 12px;
  }
  & .MuiSelect-select {
    height: 40px;
    box-sizing: border-box;
    background-color: ${colors.white};
  }
`;
